import Vue from "vue";
import Router from "vue-router";
import CreateUser from "./views/admin/CreateUser.vue";
import TheBusinessRegister from "./views/ProductsViews/TheBusinessRegister.vue";
import ClientManagmentWebSite from "./views/admin/ClientManagmentWebSite.vue";
import GoogleMyBusiness from "./views/ProductsViews/GoogleMyBusiness.vue";
import PaginasAmarillas from "./views/ProductsViews/PaginasAmarillas.vue";
import GoogleCampaigns from "./views/ProductsViews/GoogleCampaigns.vue";
import SocialMediaPost from "./views/ProductsViews/SocialMediaPost.vue";
import AmchamdrOnline from "./views/ProductsViews/AmchamdrOnline.vue";
import SocialNetwork from "./views/ProductsViews/SocialNetworks.vue";
import GoogleDisplay from "./views/ProductsViews/GoogleDisplay.vue";
import GoogleSearch from "./views/ProductsViews/GoogleSearch.vue";
import MaxPerformance from "./views/ProductsViews/MaxPerfomance";
import ClientManagment from "./views/admin/ClientManagment.vue";
import SaludOnline from "./views/ProductsViews/SaludOnline.vue";
import SpotifyAds from "./views/ProductsViews/SpotifyAds.vue";
import LinkedinAds from "./views/ProductsViews/LinkedinAds.vue";
import PlacesToGo from "./views/ProductsViews/PlacesToGo.vue";
import LocalStore from "./views/ProductsViews/LocalStore.vue";
import Discovery from "./views/ProductsViews/Discovery.vue";
import ClientConsult from "./views/admin/ClientConsult.vue";
import Resumen from "./views/ProductsViews/Resumen.vue";
import Website from "./views/ProductsViews/Website.vue";
import YouTube from "./views/ProductsViews/YouTube.vue";
import PrivacyPolicy from "./views/PrivacyPolicy.vue";
import TestGround from "./views/TestGround.vue";
import Dashboard from "./views/Dashboard.vue";
import LoadingPR from "./views/LoadingPR.vue";
import LoadingIP from "./views/LoadingIP.vue";
import Loading from "./views/Loading.vue";
import Profile from "./views/Profile.vue";
import Login from "./views/Login.vue";
import moment from "moment";
import LeadPage from "./views/Lead.vue";
import Tiktok from "./views/ProductsViews/Tiktok.vue";

Vue.use(Router);
const privacyPolicyPath = "/privacy-policy";
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: privacyPolicyPath,
      name: "privacy-policy",
      component: PrivacyPolicy
    },
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/loading",
      name: "loading",
      component: Loading
    },
    {
      path: "/loadingpr",
      name: "loadingpr",
      component: LoadingPR
    },
    {
      path: "/loadingip",
      name: "loadingip",
      component: LoadingIP
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      children: [
        {
          path: "/consulta",
          name: "ClientConsult",
          component: ClientConsult
        },
        {
          path: "/manage/",
          name: "ClientManagment",
          component: ClientManagment
        },
        {
          path: "/manage/new-account",
          name: "CreateUser",
          component: CreateUser
        },
        {
          path: "/managewebsite",
          name: "ClientManagmentwebsite",
          component: ClientManagmentWebSite
        },
        {
          path:
            "/cliente/:subscriberId/businessUnit/:businessUnitId/clientComercialName/:comercialName",
          name: "client",
          component: Resumen
        },
        {
          path: "/perfil/:subscriberId/:businessUnitId",
          name: "perfil",
          component: Profile
        },
        {
          path: `/producto/sppg/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName`,
          name: "PaginasAmarillas.com.do",
          title: "paginas-amarillas",
          component: PaginasAmarillas
        },
        {
          path: `/producto/IPPR/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName`,
          name: "infopaginas.com",
          title: "info-paginas",
          component: PaginasAmarillas
        },
        {
          path:
            "/producto/slol/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "SaludOnline.com.do",
          title: "salud-online",
          component: SaludOnline
        },
        {
          path:
            "/producto/slolpr/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "SaludOnlinePR.com.do",
          title: "salud-online",
          component: SaludOnline
        },
        {
          path:
            "/producto/ptg/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Places to Go",
          component: PlacesToGo
        },
        {
          path:
            "/producto/ptgpr/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "PlacesToGoPR",
          component: PlacesToGo
        },
        {
          path:
            "/producto/amol/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "AMCHAMDR Online",
          component: AmchamdrOnline
        },
        {
          path:
            "/producto/br/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "The Business Register",
          component: TheBusinessRegister
        },
        {
          path:
            "/producto/abg/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Anuncios en Google Search",
          component: GoogleSearch
        },
        {
          path:
            "/producto/adg/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Display de google",
          component: GoogleDisplay
        },
        {
          path:
            "/producto/smp/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Social media post",
          component: SocialMediaPost
        },
        {
          path:
            "/producto/ars/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Social network",
          component: SocialNetwork
        },
        {
          path:
            "/producto/web/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Website",
          component: Website
        },
        {
          path:
            "/producto/eco-ee/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Ecommerce",
          component: Website
        },
        // {
        //   path: "/producto/facebook-ads",
        //   name: "Anuncios en Facebook",
        //   component: ProductView
        // },
        // {
        //   path: "/producto/instagram-ads",
        //   name: "Anuncios en Instagram",
        //   component: ProductView
        // },
        // {
        //   path: "/producto/waze-ads",
        //   name: "Anuncios en Waze",
        //   component: ProductView
        // },
        {
          path:
            "/producto/ayt/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "YouTube Ads",
          component: YouTube
        },
        {
          path:
            "/producto/sebp-da/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Campañas de Generación de Demanda",
          component: Discovery
        },
        {
          path:
            "/producto/sebp-pm/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          //"/producto/sebp-da/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Anuncios de Maximo Rendimiento",
          component: MaxPerformance
        },
        {
          path:
            "/producto/gmb/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Google My Busines",
          component: GoogleMyBusiness
        },
        {
          path:
            "/producto/sebp-cl/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          //"/producto/sebp-da/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Anuncios de Local Stores",
          component: LocalStore
        },
        {
          path:
            "/producto/spy/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          //"/producto/sebp-da/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Spotify Ads",
          component: SpotifyAds
        },
        {
          path:
            "/producto/lkn/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          //"/producto/sebp-da/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Linkedin Ads",
          component: LinkedinAds
        },
        {
          path:
            "/producto/gcs/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          //"/producto/sebp-da/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Google Campaigns",
          component: GoogleCampaigns
        },
        {
          path: "/test",
          name: "TestGround",
          component: TestGround
        },
        {
          path:
            "/producto/LEAD/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Lead",
          component: LeadPage
        },
        {
          path:
            "/producto/TKTK/:productId/subscribers/:subscriberId/businessUnit/:businessUnitId/:productName",
          name: "Tiktok",
          component: Tiktok
        }

      ]
    }
  ]
});

const isNotAuthenticated = (to, from, next) => {
  let token = localStorage.getItem("user-token");
  let expirationDate = new Date(
    parseInt(localStorage.getItem("token-expiration"))
  );
  let isAuthenticated =
    token && expirationDate && moment(expirationDate).isAfter(new Date())
      ? true
      : false;

  if (to.path == privacyPolicyPath) {
    next();
  } else if (to.name !== "login" && !isAuthenticated) {
    router.push({ name: "login", path: "/" });
  } else {
    next();
  }
};

router.beforeEach((to, from, next) => {
  isNotAuthenticated(to, from, next);
});

export default router;
